'use strict';

// TODO: remove, semver-major

module.exports = require('get-intrinsic');



//////////////////
// WEBPACK FOOTER
// ./node_modules/es-abstract/GetIntrinsic.js
// module id = 1558
// module chunks = 8